export enum LayoutClassName {
  HEADER = 'ja-layout-header',
  SCROLL_CONTAINER = 'ja-layout-scroll-container'
}
